var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-dealer pad"},[_c('div',{staticClass:"pad"},[_c('dealer-form',{on:{"submitted":_vm.submitted}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }